import DefaultModal from '@/components/Modals/DefaultModal'
import ConfirmCancelModalFooter from '@/components/Modals/ConfirmCancelModalFooter'
import { Flex } from '@/components/Flex'
import { Headline2, InfoLabel, Label } from '@/components/Typography'
import { useModal } from '@/hooks/useModal'
import { DefaultModalProp } from '@/typings/Modals'

import { useDeleteSubnet } from '../application/hooks/useDeleteSubnet'

export default function DeleteSubnetModal({
  setOpen,
  ...props
}: DefaultModalProp) {
  const modal = useModal('deleteSubnet')
  const deleteMutation = useDeleteSubnet()

  const { subnetId, subnetName, cidr, clusterName } = modal.data

  const onConfirm = () => {
    deleteMutation.mutate(
      { id: subnetId, isAssigned: Boolean(clusterName) },
      {
        onSuccess: () => modal.close(),
      },
    )
  }

  return (
    <DefaultModal
      {...props}
      setOpen={setOpen}
      type="deleteSubnet"
      modalHeader={<Headline2>Delete Subnet</Headline2>}
      modalBody={
        <Flex flexDirection="column" width="100%" mt="1rem" gap="0.75rem">
          <Label>
            Delete subnet &quot;{subnetName}&quot; ({cidr})? This cannot be
            undone.
          </Label>
          {clusterName && (
            <InfoLabel>
              This subnet is assigned to cluster &quot;{clusterName}&quot; —
              the backend currently rejects deleting an assigned subnet, and
              unassigning does not exist yet. If it refuses, the refusal is
              shown as is.
            </InfoLabel>
          )}
        </Flex>
      }
      modalFooter={ConfirmCancelModalFooter}
      isLoading={deleteMutation.isPending}
      onConfirm={onConfirm}
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
    />
  )
}
